function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

var React = require("react");

var tag = require("tag-hoc").default;

var color = require("color");

var styled = require("styled-components").default;

var remark = require("remark");

var emoji = require("remark-gemoji-to-emoji");

var Icon = require("@patternplate/component-icon").Icon;

var Link = require("@patternplate/component-link").Link;

var processor = remark().use(emoji);

var NavigationItem =
/*#__PURE__*/
function (_React$Component) {
  _inherits(NavigationItem, _React$Component);

  function NavigationItem() {
    var _ref;

    var _this;

    _classCallCheck(this, NavigationItem);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_ref = NavigationItem.__proto__ || Object.getPrototypeOf(NavigationItem)).call.apply(_ref, [this].concat(args)));
    _this.getRef = _this.getRef.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(NavigationItem, [{
    key: "getRef",
    value: function getRef(ref) {
      this.ref = ref;
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      if (this.props.active && this.ref) {
        setTimeout(function () {
          _this2.props.onScrollRequest({
            target: _this2.ref,
            props: _this2.props
          });
        });
      }
    }
  }, {
    key: "componentWillUpdate",
    value: function componentWillUpdate(next) {
      if (this.props.type === "folder") {
        return;
      }

      if (next.active && this.ref) {
        this.props.onScrollRequest({
          target: this.ref,
          props: next
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var props = this.props;
      var title = props.title || "Navigate to ".concat(props.name, " ").concat(props.type);
      var symbol = props.active ? props.symbolActive : props.symbol;
      var name = processor.processSync(props.name).contents;
      return React.createElement(StyledNavigationItem, {
        active: props.active,
        className: props.className,
        ref: this.getRef,
        type: props.type
      }, React.createElement(StyledNavigationLink, {
        active: props.active,
        external: props.external,
        onClick: props.onClick,
        href: props.href,
        sticky: props.type === "folder" && props.active,
        type: props.type,
        title: title,
        nested: props.nested,
        iconSize: "s",
        grow: true,
        hint: true
      }, symbol && React.createElement(StyledIcon, {
        active: props.active,
        size: "m",
        symbol: symbol
      }), React.createElement(StyledName, null, props.name), props.meta && React.createElement(StyledMeta, {
        active: props.active
      }, props.meta)), props.active && props.children);
    }
  }]);

  return NavigationItem;
}(React.Component);

module.exports = NavigationItem;
var StyledIcon = styled(Icon).withConfig({
  displayName: "navigation-item__StyledIcon"
})(["flex:0 0 auto;fill:", ";", ";padding:10px 0 10px 9px;"], function (props) {
  return props.theme.colors.color;
}, function (props) {
  return props.active && "fill: ".concat(color(props.theme.colors.active));
});
var StyledName = styled.div.withConfig({
  displayName: "navigation-item__StyledName"
})(["box-sizing:border-box;flex:1 1 100%;padding:10px;"]);
var StyledMeta = styled.div.withConfig({
  displayName: "navigation-item__StyledMeta"
})(["flex:1 0 auto;margin:0 ", "px 0 auto;"], function (props) {
  return props.active ? 6 : 10;
});
var StyledNavigationItem = styled.div.withConfig({
  displayName: "navigation-item__StyledNavigationItem"
})(["width:100%;box-sizing:border-box;margin-left:1px;"]);
var LinkTag = tag(["active", "type"])(Link);
var StyledNavigationLink = styled(LinkTag).withConfig({
  displayName: "navigation-item__StyledNavigationLink"
})(["box-sizing:border-box;display:flex;width:100%;align-items:center;text-decoration:none;font-size:", "px;line-height:20px;font-family:", ";font-weight:", ";padding-left:", "px;:link,:visited{color:", ";", ";}"], function (props) {
  return props.theme.fonts.fontSize;
}, function (props) {
  return props.theme.fonts.default;
}, function (props) {
  return props.theme.fonts.fontWeight;
}, function (props) {
  return props.nested ? 30 : 0;
}, function (props) {
  return props.theme.colors.color;
}, function (props) {
  return props.active && "color: ".concat(color(props.theme.colors.active));
});
//# sourceMappingURL=index.js.map